import { useCallback } from "react";
import { useToast } from "@/components/ToastProvider";
import { parseApiError } from "@/lib/errors";

export function useUnifiedErrorSurface() {
  const { push } = useToast();

  const notifyError = useCallback(
    (error: unknown, fallbackTitle = "Error") => {
      const { title, message } = parseApiError(error, fallbackTitle);
      push({ title, message });
    },
    [push],
  );

  return { notifyError };
}
